import { Component, Ref, Prop} from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { SitePopup } from "../SitePopup/SitePopup";
import { log } from 'console';

@Component
export class FindABox extends ThemeComponent {
    @Ref form!: HTMLFormElement;
    @Ref length!: HTMLInputElement;
    @Ref width!: HTMLInputElement;
    @Ref height!: HTMLInputElement;
    @Ref refSearch!: HTMLInputElement;
    @Ref hiddenInput!: HTMLInputElement;
    @Ref selectUnit!: HTMLSelectElement;
    @Ref modalTrigger!: HTMLButtonElement;
    @Ref closeModal!: HTMLButtonElement;
    @Prop() modal!: boolean;

    private sitePopup: SitePopup|null = document.querySelector('site-popup');

    init() {
        this.setEventListeners();

        if(this.modal) { this.mobileModal(); }
    }

    protected setEventListeners() {
        // Listen for last active input
        const inputs = this.querySelectorAll('.find-a-box__input') as NodeList;
        for (const input of inputs) {
            this.$listen(input as HTMLElement, 'keyup', (e) => {
                this.updateSearchType(e);
            });
        }

        this.$listen(this.form, 'submit', (e) => {
            e.preventDefault();
            this.formSubmit();
        });
    }

    private updateSearchType(e: KeyboardEvent) {
        const target = e.target as HTMLInputElement;
        const val = target.dataset?.ref;

        let hiddenVal = 'ref';
        if (val === 'length' || val === 'height' || val === 'width') {
            hiddenVal = 'size';
        }

        this.hiddenInput.value = hiddenVal;
    }

    private formSubmit() {
        let url = '';
        let reference = this.refSearch.value;
        const searchType = this.hiddenInput.value;
        const units = this.selectUnit.value;
        const length = this.convertToMM(this.length.value, units);
        const width = this.convertToMM(this.width.value, units);
        const height = this.convertToMM(this.height.value, units);
        const dimensions = [length, width, height];

        // split ref in case it contains size
        if (reference.indexOf('_') !== -1) {
            reference = reference.split('_')[0];
        }

        if (searchType == 'size') {
            url = "/collections/cardboard-boxes/#/f1:length/f2:width/f3:height/s:asc~box_sizing/";
            url = url.replace("length", dimensions[0]).replace("width", dimensions[1]).replace("height", dimensions[2]);
        }

        if (searchType == 'ref') {
            url = "/collections/all/#/f4:" + reference + "/f10:Any";
        }

        window.location.href = url;
        setTimeout(function() {
            window.location.reload();
        }, 1200);
    }

    private convertToMM(number: string, oldUnit: string) {
        if (oldUnit == "inches") {
            return (Number(number) * 25.4).toFixed(0);
        }

        if (oldUnit == "cm") {
            return (Number(number) * 10).toFixed(0);
        }

        return number;
    }

    private mobileModal() {
        this.sitePopup = document.querySelector('.site-popup') as SitePopup;
        const sitePopupContent = this.sitePopup.querySelector('.site-popup__content');
        const content = this.form;

        this.$listen(this.modalTrigger, 'click', () => {
            sitePopupContent?.append(content);
            if (!this.sitePopup) { return; }
            this.sitePopup.open('find-a-box');
        });

        this.$listen(this.closeModal, 'click', () => {
            this.sitePopup?.close();
        });
    }
}
